<template>
<div>

     <b-modal
      id="modal-class-details"
      ref="modal-class-details"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      centered
      
      button-size="sm"
      size="md"
      title="Class Details"
    >
    <b-overlay
      :show="loading"
      rounded="sm"
    >

        <b-row class="my-2">
          <!-- Right: Product Details -->
          <b-col
            cols="12"
            md="12"
          >

            <!-- Product Name -->
            <h4>Class 1 - Soccer</h4>

            <!-- Product Brand -->
            <b-card-text class="item-company mb-0">
              <span>Tutor</span>
              <b-link class="company-name">
                 : Peter Lee
              </b-link>
            </b-card-text>

            <!-- Price And Ratings -->
            <div class="ecommerce-details-price d-flex flex-wrap mt-1">
              <h4 class="item-price mr-1">
                $400
              </h4>
              <!-- <ul class="unstyled-list list-inline pl-1 border-left">
                <li
                  v-for="star in 5"
                  :key="star"
                  class="ratings-list-item mr-25"
                >
                  
                </li>
              </ul> -->
            </div>

            <!-- Avability -->
            <b-card-text  class="text-success" >Available </b-card-text>
            <hr>
            <!-- Product Description -->
            <b-card-text>
              This is a beginner level soccer class suitable for children aged 6-10. The class focuses on basic skills, teamwork, and fun activities to foster a love for the game.
            </b-card-text>

            <!-- Product Meta [Free shpping, EMI, etc.] -->
            

            <hr>

            <!-- Colors -->
            <div class="product-color-options">
              <h6>Enrolment Date</h6>
              <b-row>
                <b-col cols="6">11 November 2025 16:00 - 17:00</b-col>
                <b-col cols="6">13 November 2025 </b-col>
                <b-col cols="6">18 November 2025 </b-col>
                <b-col cols="6">20 November 2025 </b-col>
                <b-col cols="6">25 November 2025 </b-col>
                <b-col cols="6">27 November 2025 </b-col>
              </b-row>
              <ul class="list-unstyled mb-0">
                
              </ul>
            </div>

            <hr>
            <div v-if="userData.has_credit_card == false" class="mb-1">
              <b-form-group
               label="Credit Card Number"
               label-for="card"
             >
               <b-form-input
                 id="card"
                  v-mask="'#### #### #### ####'"
                 v-model="card.number"
                 trim
               />

             </b-form-group>
             <b-row>
              <b-col cols="6"> <b-form-group
             label="Expiry Date (YYYY-MM)"
             label-for="Expiry Date"
           >
             <b-form-input
               id="expire"
               v-mask="'####-##'"
               v-model="card.expire"
               trim
             />

           </b-form-group></b-col>
           <b-col cols="6">
  <b-form-group
            label="CVC"
            label-for="cvc"
          >
            <b-form-input
              id="cvc"
              v-mask="'###'"
              v-model="card.cvc"
              trim
            />

          </b-form-group>
           </b-col>
             </b-row>
          

        
          <hr class="my-2"/>
              </div>
            <div class="d-flex flex-column flex-sm-row">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-cart mr-0 mr-sm-1 mb-1 mb-sm-0"
                @click="apply()"
              >
                <feather-icon
                  icon="ShoppingCartIcon"
                  class="mr-50"
                />
                <span>Apply</span>
              </b-button>
              <!-- <b-button
                variant="outline-secondary"
                class="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
              >
                <feather-icon
                  icon="HeartIcon"
                  class="mr-50"
                />
                <span>Wishlist</span>
              </b-button> -->
              
            </div>
          </b-col>
        </b-row>
    </b-overlay>

    <template #modal-footer="{ ok , closeModal  }">

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
  </b-modal>
<b-row>
  <b-col
    cols="9"
  >
  <b-card>
    <b-row>
      <b-col
        cols="21"
        xl="6"
        class="d-flex justify-content-between flex-column"
      >
        <div class="d-flex justify-content-start">
          
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-0">
               {{userData.en_name}} {{userData.zh_name}}
              </h4>
              <span class="card-text">{{userData.email}}</span>
            </div>
            
          </div>
        </div>

        <div class="d-flex align-items-center mt-2">
          <div class="d-flex align-items-center mr-2">
            <b-avatar
              variant="light-primary"
              rounded
            >
              <feather-icon
                icon="WatchIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                12 Dec 2025
              </h5>
              <small>下次上堂日期</small>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <b-avatar
              variant="light-success"
              rounded
            >
              <feather-icon
                icon="BookmarkIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                Paint Basic Class
              </h5>
              <small>下次上課名稱</small>
            </div>
          </div>
        </div>
      </b-col>

      <b-col
        cols="12"
        xl="6"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Remaing Enrolment</span>
            </th>
            <td class="pb-50">
             23
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="CheckIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Registered Class</span>
            </th>
            <td class="pb-50 text-capitalize">
             2
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="StarIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Absent Enrolment</span>
            </th>
            <td class="pb-50 text-capitalize">
              0
            </td>
          </tr>
        
        </table>
      </b-col>
    </b-row>
  </b-card>
  </b-col>
  <b-col
    cols="3"
  >
   <v-calendar
            :firstDayOfWeek="0"
            title-position="center"
            :rows="1"
            style="width:100%"
            @dayclick='dayClicked'
            :attributes="attributes" />
            </b-col>  
<b-col
    cols="6"
    class="mt-2"
  >
<b-card class="mt-2">
  <h5 class="my-1">Available Classes</h5>
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="items"
      :fields="fields"
      responsive
      striped
      @row-selected="onRowSelected"
    >
      <!-- A virtual column -->
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <!-- A custom formatted column -->
      <template #cell(name)="data">
        {{ data.value.first+' - '+ data.value.last }}
      </template>

      <!-- A custom formatted column -->
      <template #cell(Popularity)="data">
        <b-progress
          :value="data.value.value"
          max="100"
          :variant="data.value.variant"
          striped
        />
      </template>

      <template #cell(order_status)="data">
        <b-badge
          pill
          :variant="data.value.variant"
        >
          {{ data.value.status }}
        </b-badge>
      </template>

      <!-- A virtual composite column -->
      <template #cell(price)="data">
        {{ '$'+data.value }}
      </template>

      <!-- Optional default data cell scoped slot -->
      <template #cell()="data">
        {{ data.value }}
      </template>
    </b-table>
    </b-card>
    </b-col>
    <b-col
    cols="6"
    class="mt-2"
  >
<b-card class="mt-2">
   <h5 class="my-1">Applied Classes</h5>
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="applied_classes"
      :fields="applied_fields"
      responsive
      striped
      @row-selected="onRowSelected"
    >
      <!-- A virtual column -->
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <!-- A custom formatted column -->
      <template #cell(name)="data">
        {{ data.value }}
      </template>
      <template #cell(status)="data">
        <b-badge
          pill
          variant="warning"
        >
          {{ data.value }}
        </b-badge>
      </template>
      <!-- A custom formatted column -->
      <template #cell(Popularity)="data">
        <b-progress
          :value="data.value.value"
          max="100"
          :variant="data.value.variant"
          striped
        />
      </template>

      <template #cell(order_status)="data">
        <b-badge
          pill
          :variant="data.value.variant"
        >
          {{ data.value.status }}
        </b-badge>
      </template>

      <!-- A virtual composite column -->
      <template #cell(price)="data">
        {{ '$'+data.value }}
      </template>

      <!-- Optional default data cell scoped slot -->
      <template #cell()="data">
        {{ data.value }}
      </template>
    </b-table>
    </b-card>
    </b-col>
    </b-row>  
</div>
</template>



<script>
import {
  BTable,BOverlay,BModal, BCardText,BCardBody,BProgress, BDropDown,BBadge,BAlert, BLink, BAvatar,BCard, BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton, BTab, BTabs,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import Ripple from 'vue-ripple-directive'
export default {
  components: {
    ToastificationContent,
    BTable, 
    BOverlay,
    BDropDown,
    BCardText,
    Ripple,
    BProgress, 
    BBadge,
    BCardBody,
    vSelect,
    flatPickr,
    BModal,
    BForm,
    BAvatar,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BRow,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
  },
  data() {
    return {
      loading:false,
      selectMode: 'single',
      applied_classes: [],
        fields: [
        // A virtual column that doesn't exist in items
         { key: 'index', label: '#' },
        // A column that needs custom formatting
        { key: 'name', label: 'Class' },
        'Category',
      ],
      applied_fields: [
        { key: 'index', label: '#' },
        { key: 'name', label: 'Class' },
        { key: 'status', label: 'Status' }
      ],
      items: [
        {
          name: { first: '', last: 'Soccer' },
          Category: 'Sport'
         
        },
        {
          name: { first: '', last: 'Badminton' },
          Category: 'Sport'
        },
        {
          name: { first: '', last: 'Piano' },
          Category: 'Music'
        },
        
      ],
      iframe_src: '',
      paymentMethods:[],
      centerOptions: [],
      student: router.currentRoute.params.id,
      client_module:JSON.parse(localStorage.getItem('userData')),
      card: {
        number : null,
        expire : null,
        cvc: null,
      },
      userData: {
        display_name: null,
        exsiting_username: null,
      },
      statusOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Disabled', value: 'disabled' },
      ],
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],
      dates: [],
    } 
  },
  computed: {
    attributes() {
      return [
        {
          dot: true,
          bar: true,
          key: 'today',
          highlight: {
            color: 'gray',
            fillMode: 'solid',

          },
          //dates: moment('2023-01-10').format()
        }, 
        ...this.dates.map(date => ({
          highlight: date.color,
          dates: date.class_date,
          popover: {
            label:  date.name + " " + date.start,
            enrollment_id : date.id
          },
        })),
      ];
    },
  },
  created() {
    this.get_student_data()
    //this.get_center_data()
  },
  methods: {
    apply(){
      this.loading = true
      this.$http.post(process.env.VUE_APP_API_BASE+'/class/1/apply/', 
      { student_id: this.userData.id, 
        class_list_id: '123',
        card: this.card 
      })
        .then(res => {
          this.loading = false
          if (res.data.result === true) {
             this.get_student_data()
             this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckCircleIcon',
                variant: 'success',
                text: 'Enrolment successful!',
              },
            })
            this.close()
            this.get_student_data()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'AlertCircleIcon',
                variant: 'danger',
                text: res.data.message
              },
            })
          }
        })      
    },
    onRowSelected(items) {
      console.log(items)
      this.selected = items
      this.$refs['modal-class-details'].show()
    },
    dayClicked(day) {
      // console.clear()
      // console.log(day.attributes[0].popover.enrollment_id)
     // this.delete_enrollment(day.attributes[0].popover.enrollment_id)
    },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    close() {
      this.$refs['modal-class-details'].hide()
    },
    get_student_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/me/`)
        .then(res => {
          if (process.env.VUE_APP_VERSION != res.data.version) {
          //  this.$router.go(0);
          }
          this.userData = res.data.student
          this.applied_classes = res.data.applied_classes
          this.dates = res.data.enrollments
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

